import type { CheckboxProps } from "@mui/material"
import { Checkbox, FormControlLabel } from "@mui/material"
import type { ReactElement, ReactNode } from "react"
import { forwardRef } from "react"

export interface AerosCheckboxProps extends Omit<CheckboxProps, "onChange"> {
  label?: ReactNode
  onChange?: (checked: boolean) => void
}

export const AerosCheckbox = forwardRef<HTMLButtonElement, AerosCheckboxProps>(
  ({ label, disabled, onChange, className, ...props }, ref): ReactElement => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange?.(e.target.checked)
    }

    return (
      <FormControlLabel
        className={className}
        control={<Checkbox {...props} ref={ref} onChange={handleChange} />}
        label={label}
        disabled={disabled}
      />
    )
  }
)
